import _getNative_default from "./_getNative.js";

//#region ../../node_modules/lodash-es/_nativeCreate.js
var nativeCreate = _getNative_default(Object, "create");
var _nativeCreate_default = nativeCreate;

//#endregion
export { _nativeCreate_default as default };
//# sourceMappingURL=_nativeCreate.js.map